import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'
import { currentUser } from 'app/modules/user/selectors'
import { orgId } from 'app/modules/org/selectors'
import app from 'containers/app'
import * as UserActions from 'app/modules/user/actions'
import { api } from './api'
import * as actions from './actions'
import * as selectors from './selectors'

function fetchProperties(action$, { getState }) {
  return action$
    .ofType(actions.fetchUserProperties.toString())
    .filter(() => !selectors.propertiesLoaded(getState()))
    .pluck('payload')
    .exhaustMap(() => {
      const user = currentUser(getState())
      return api.fetch(user.id)
        .map(actions.receiveUserProperties)
        .startWith(actions.fetchUserPropertiesPending({ user }))
        .catch(error => {
          return Observable.of(actions.fetchUserPropertiesFailed({ error, user }))
        })
    })
}

const updateUserPropAndNotify = (apiCall, { notify, user, properties }) => apiCall(user.id, properties)
  .map(newProperties => {
    if (notify) {
      app.actions.NotificationActions.pushNotification({
        content: "Your settings have been saved.",
        variant: "green",
      })
    }
    return actions.receiveUserProperties(newProperties)
  })
  .startWith(actions.updateUserPropertiesPending(properties))
  .catch(error => {
    return Observable.of(actions.updateUserPropertiesFailed({ error, user }))
  })


function updateProperties(action$, { getState }) {
  return action$
    .ofType(actions.updateUserProperties.toString())
    .pluck('payload')
    .mergeMap(({ properties, notify = true }) => {
      const user = currentUser(getState())
      return updateUserPropAndNotify(api.update, { notify, user, properties })
    })
}

function updateClassificationsNotificationProperties(action$, { getState }) {
  return action$
    .ofType(actions.updateClassificationsNotificationProperties.toString())
    .pluck('payload')
    .mergeMap(({ properties, notify = true }) => {
      const state = getState()
      const user = currentUser(state)
      return updateUserPropAndNotify(api.patchClassificationNotificationProperties, { notify, user, properties })
    })
}

function updateExtensionUserProperties(action$, { getState }) {
  return action$
    .ofType(actions.updateExtensionUserProperty.toString())
    .pluck('payload')
    .mergeMap(({ properties, notify = true }) => {
      const state = getState()
      const user = currentUser(state)
      const existingExtensionUserProperties = selectors.extensionProperties(state)
      return updateUserPropAndNotify(api.patchExtensionProperties, { notify, user, properties: { newProperties: properties, existingExtensionUserProperties } })
    })
}

function updateOutboundNotificationProperties(action$, { getState }) {
  return action$
    .ofType(actions.updateOutboundNotificationProperties.toString())
    .pluck('payload')
    .mergeMap(({ properties, notify = true }) => {
      const state = getState()
      const user = currentUser(state)
      return updateUserPropAndNotify(api.patchOutboundNotificationProperties, { notify, user, properties })
    })
}


function fetchCurrentUserProperties(action$) {
  return action$.ofType(UserActions.receiveCurrentUser.toString())
    .map(() => actions.fetchUserProperties())
}

function fetchUsersByPropertyName(action$, { getState }) {
  return action$
    .ofType(actions.fetchUsersByPropertyName.toString())
    .pluck('payload')
    .switchMap((properties) => {
      return api.fetchUsersByPropertyName(orgId(getState()), properties)
        .map((response) => actions.fetchUsersByPropertyNameSuccess(response))
        .startWith(actions.fetchUsersByPropertyNamePending({ properties }))
        .catch(error => {
          return Observable.of(actions.fetchUsersByPropertyNameFailure({ error, properties }))
        })
    })
}

function receiveConversationLimitUserProperty(action$) {
  return action$.ofType(actions.receiveUserProperties.toString())
    .map((action) => {
      return actions.userAtConversationLimitUpdate(action.payload.get('atConversationLimit'))
    })
}

export const epic = combineEpics(
  fetchProperties,
  updateProperties,
  updateExtensionUserProperties,
  updateClassificationsNotificationProperties,
  updateOutboundNotificationProperties,
  fetchCurrentUserProperties,
  fetchUsersByPropertyName,
  receiveConversationLimitUserProperty
)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/user/properties/epic.js